<template>
    <div class="row col-md-12 m-b-30 filter-container">
        <SelectEmployee class="employee-form-item"
                      v-if="filterUsername"
                      @name="name => username = name"
                      :defaultEmployee="defaultUser()"
                      :placeholder="defaultUsername"
                      :required="false"
                      :formInputResetFlag="resetFlags.username"/>
        <SelectOption class="employee-form-item"
                      v-if="filterArea"
                      :options="areaNames"
                      :placeholder="defaultFieldValue"
                      :required="false"
                      :label="'Dział'"
                      :id="'area-select'"
                      v-model="areaName"
                      style="margin-top: 0.75em;"
                      :formInputResetFlag="resetFlags.area"
                      />
        <SelectOption class="employee-form-item"
                      v-if="filterProject"
                      :options="projectNames"
                      :placeholder="defaultFieldValue"
                      :required="false"
                      :label="'Projekt'"
                      :id="'project-select'"
                      v-model="projectName"
                      style="margin-top: 0.75em;"
                      :formInputResetFlag="resetFlags.project"/>
      <SelectOption class="employee-form-item"
                      v-if="filterCompany"
                      :options="companiesNames"
                      :placeholder="defaultFieldValue"
                      :required="false"
                      :label="'Firma'"
                      :id="'company-select'"
                      v-model="companyName"
                      style="margin-top: 0.75em;"
                      :formInputResetFlag="resetFlags.company"
                      />
    </div>
</template>

<script>
    import {backend} from "../../backend.js";

    import SelectOption from '../SelectOption.vue';
    import SelectEmployee from "../SelectEmployee.vue";

    export default {
        name: "EmployeeFilter",
        components: {
            SelectEmployee,
            SelectOption
        },
        props: {
            defaultFieldValue: {
                type: String,
                default: "Wszystkie",
            },
            defaultUsername: {
                type: String,
                default: "Wszyscy",
            },
            fields: {
                type: Array,
                required: true,
            },
            defaultLogged: {
                type: Boolean,
                default: true,
            }
        },
        data() {
            return {
                areas: [],
                projects: [],
                companies: [],
                loggedUsername: null,
                projectName: this.defaultFieldValue,
                areaName: this.defaultFieldValue,
                companyName: this.defaultFieldValue,
                username: null,
                users: [],
                loaded: false,
                resetFlags: {},
            }
        },
        created: function () {
            let flags = {};
            for (let field of this.fields) {
                flags[field] = true;
            }
            this.resetFlags = flags;
            backend.getRemoteUsers()
                .then((response) => {
                    this.users = response.data;
                    this.loaded = true;
                }).catch(() => {
                    this.$vs.notify({text: 'Nie udało się pobrać listy pracowników.', color: 'danger'});
                });
            if (this.filterProject) {
                backend.getProjects()
                    .then((response) => {
                        this.projects = response.data;
                    }).catch(() => {
                        this.$vs.notify({text: 'Nie udało się pobrać listy projektów.', color: 'danger'});
                    });
            }
            if (this.filterArea) {
                backend.getAreas()
                    .then((response) => {
                        this.areas = response.data;
                    }).catch(() => {
                        this.$vs.notify({text: 'Nie udało się pobrać listy działów.', color: 'danger'});
                    });
            }
            if (this.filterCompany) {
                backend.getCompanies()
                    .then((response) => {
                        this.companies = response.data;
                    }).catch(() => {
                        this.$vs.notify({text: 'Nie udało się pobrać listy firm.', color: 'danger'});
                    });
            }
            if (this.filterUsername) {
                this.loggedUsername = this.$store.getters['auth/username'];
                if (this.defaultLogged) {
                    this.username = this.loggedUsername;
                }
            }
        },
        computed: {
            filterUsername() {
                return this.resetFlags['username'] !== undefined;
            },
            filterArea() {
                return this.resetFlags['area'] !== undefined;
            },
            filterProject() {
                return this.resetFlags['project'] !== undefined;
            },
            filterCompany() {
                return this.resetFlags['company'] !== undefined;
            },
            areaNames() {
                return this.areas.map(area => area.name);
            },
            companiesNames() {
                return this.companies.map(company => company.name);
            },
            projectNames() {
                return this.projects.map(project => project.name);
            },
            area() {
                return this.areas.find(area => area.name === this.areaName);
            },
            project() {
                return this.projects.find(project => project.name === this.projectName);
            },
            company() {
                return this.companies.find(company => company.name === this.companyName);
            },
            queryParams() {
                let params = {};
                if (this.filterProject && this.project !== undefined) {
                    params.project = this.project.id;
                }
                if (this.filterArea && this.area !== undefined) {
                    params.area = this.area.id;
                }
                if (this.filterCompany && this.company !== undefined) {
                    params.company = this.company.id;
                }
                if (this.filterUsername && this.username !== this.defaultUsername) {
                    if (this.username != null)
                        params.username = this.username;
                }
                return params;
            }
        },
        watch: {
            project(v) {
                if (v !== undefined) {
                    this.resetFieldsOtherThan('project');
                }
            },
            area(v) {
                if (v !== undefined) {
                    this.resetFieldsOtherThan('area');
                }
            },
            company(v) {
                if (v !== undefined) {
                    this.resetFieldsOtherThan('company');
                }
            },
            username(v) {
                if (v !== this.defaultUsername) {
                    this.resetFieldsOtherThan('username');
                }
            },
            queryParams: function (new_params) {
                if (this.loaded && Object.keys(new_params).length <= 1) {
                    this.$emit('params', new_params);
                    this.$emit('filteredUsers', this.filteredUsers(new_params));
                }
            },
        },
        methods: {
            resetFieldsOtherThan: function (field) {
                for (let f in this.resetFlags) {
                    if (this.resetFlags.hasOwnProperty(f) && f !== field) {
                        this.resetFlags[f] = !this.resetFlags[f];
                        console.log(this.resetFlags[f])
                    }
                }
            },
            filteredUsers: function (params) {
                let modifiedParams = JSON.parse(JSON.stringify(params));
                if (params.username !== undefined) {
                    modifiedParams['login'] = params['username'];
                }
                delete modifiedParams['username'];
                return this.users.filter(user => {
                    for (let param in modifiedParams) {
                        if (modifiedParams.hasOwnProperty(param)) {
                            if (user[param] !== modifiedParams[param]) {
                                return false;
                            }
                        }
                    }
                    return true;
                });
            },
            defaultUser: function () {
                if (this.defaultLogged) {
                    return this.loggedUsername;
                } else {
                    return this.defaultUsername;
                }
            }
        }
    }
</script>

<style scoped>
    .employee-form-item {
        margin-right: 2em;
    }

    .filter-container {
        display: inline-flex;
        align-items: center;
    }


</style>


// WEBPACK FOOTER //
// EmployeeFilter.vue?5ff0c7a1